import { validateLocationByMode } from 'shared/utils/address';
import type { TCoordinatesFields, TAddressFields, ELocationMode } from 'components/trips/trip-create-task-modal/types';

export const validateLocationForm = (
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
) => {
  return validateLocationByMode(locationMode, coordinates, address);
};
